// extracted by mini-css-extract-plugin
module.exports = {"root":"author-module__root___Hgk2I","label":"author-module__label___2EpBu","value":"author-module__value___2DaII","inventory":"author-module__inventory___2d0nk"};